/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import ButtonIconSquare from 'DesignSystem/ButtonIconSquare/index'
import Gotoform01 from 'DesignSystem/Svgs/Gotoform01/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Complete/MedicalForm/Content/MedicalFormUrl/Content/Content/Link/Content"
  
}) {
let selectedMedicalFormUrlValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'medical_form_url',
})
  return (<React.Fragment
>
<a
 href={selectedMedicalFormUrlValueData} rel='noopener noreferrer' target='_blank'
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<ButtonIconSquare
  viewPath={`${viewPath}/ButtonIconSquare`}
 height={340}
 marginTopText={30}
 text="Complete Patient's Medical Form"
 width={340}
>
{childProps => (
<Gotoform01
{...childProps}
  viewPath={`${viewPath}/Gotoform01`}
 height={240}
 width={340}
/>
)}
</ButtonIconSquare>
</a>
{children}
</React.Fragment>)
}